import { PublicationTypeDto } from '@/api/ApiClient';

/**
 * Maps publication type abbreviations to display names.
 */
export const PUBLICATION_TYPE_DISPLAY: Record<PublicationTypeDto, string> = {
  [PublicationTypeDto.InHouse]: 'In-House',
  [PublicationTypeDto.External]: 'External User',
  [PublicationTypeDto.Local]: 'Local User',
};

/**
 * Converts publication type abbreviation to display label.
 */
export function getPublicationTypeDisplay(type: PublicationTypeDto | string | undefined): string {
  if (!type) return '';
  if (type in PUBLICATION_TYPE_DISPLAY) {
    return PUBLICATION_TYPE_DISPLAY[type as PublicationTypeDto];
  }
  return String(type);
}
